
namespace TabAurous.Sales {
    export enum SalesFilters {
        Weekly = 0,
        Monthly = 1,
        Yearly = 2
    }

    Serenity.Decorators.registerEnumType(SalesFilters, 'Custom.SalesFilters', 'Custom.SalesFilters');

    @Serenity.Decorators.registerClass()
    export class CategoryWiseSalesGrid extends Serenity.EntityGrid<SalesItemsRow, any> {
        protected getColumnsKey() { return 'Sales.CategoryWiseQuarterlySales'; } 
        protected getIdProperty() { return SalesItemsRow.idProperty; }
        protected getInsertPermission() { return SalesItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return SalesItemsRow.localTextPrefix; }
        protected getService() { return CategoryWiseSalesService.baseUrl; }
        private treeMixin: Serenity.TreeGridMixin<SalesItemsRow>;
 
        constructor(container: JQuery) {
            super(container);

            new Serenity.HeaderFiltersMixin({
                grid: this
            });
            this.slickGrid.setOptions({ rowHeight: 30 });
            //this.addDateRangeFilter("TransDate", "Date");
            this.setTitle("");
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            //grid.registerPlugin(this.autoSize);
            grid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());


            var plugin = new Slick.ColumnGroup();
            grid.registerPlugin(plugin);

            var columns = grid.getColumns();

            //grid.registerPlugin(new Slick.columng);

            for (let col of columns) {
                //console.log(col);
                if (col.field == "Quarter1Pieces" || col.field == "Quarter1Amount") col.groupName = "Quarter 1";

                if (col.field == "Quarter2Pieces" || col.field == "Quarter2Amount") col.groupName = "Quarter 2";
                if (col.field == "Quarter3Pieces" || col.field == "Quarter3Amount") col.groupName = "Quarter 3";
                if (col.field == "Quarter4Pieces" || col.field == "Quarter4Amount") col.groupName = "Quarter 4";
            }

            plugin.enableColumnGrouping();


            //this.view.setSummaryOptions({
            //    aggregators: [
            //        new Slick.Aggregators.Sum('Pieces'),
            //        new Slick.Aggregators.Sum('Weight'),
            //        new Slick.Aggregators.Sum('NetWeight'),
            //        new Slick.Aggregators.Sum('GrossAmount')]
            //});


            //this.view.setGrouping([{
            //    formatter: g => {
            //        return "<span class='slick-group-title-header'>" +
            //            g.value +
            //            "<span class='slick-cell l5 r5'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.Pieces + "</span></span>" +
            //            "<span class='slick-cell l6 r6'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.Weight.toFixed(3) + "</span></span>" +
            //            "<span class='slick-cell l7 r7'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.NetWeight + "</span></span>" +
            //            "<span class='slick-cell l11 r11'><span style='font-weight: bold;text-align: right;float:right;'>" + g.totals.sum.GrossAmount + "</span></span>";
            //    },
            //    getter: 'VoucherNo',
            //    displayTotalsRow: false,
            //}])
            return grid;
        }
        protected usePager() {
            return true;
        }
        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            opt.showFooterRow = true;
            return opt;
        }
        protected getQuickFilters() {
            var filters = super.getQuickFilters();

            //filters.push({
            //    type: Serenity.EnumEditor,
            //    options: {

            //        enumType: SalesFilters

            //    },
            //    title: 'Duration',
            //    handler: w => {
            //        var filter = Q.parseInteger(w.value);
            //        (this.view.params as TransactionRequest).SalesFilter = filter;
            //    },

            //    cssClass: 'hidden-xs'
            //});


            return filters;
        }
        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);
            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row) as Sales.SalesItemsRow;
            //To Set Master Product Image
            if (!isNaN(item.CategoryId)) {
                var categoryid = item.CategoryId;
                var dialog = new Common.SalesSummaryReportDialog(); 
                dialog.dialogOpen();
            }
            var target = $(e.target);
        }

        protected getButtons(): Serenity.ToolButton[] {
            super.getButtons();
            var buttons = super.getButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            buttons.push({
                title: 'Export',
                cssClass: 'send-button',
                //icon: 'fa-cloud-download',
                onClick: () => {

                    var items = this.view.getItems();
                    if (items.length == 0) {
                        q.alert("Warning", "No data to export", true, 2999);
                        return;
                    }
                    // Q.resolveUrl(SubCategoryMasterService.baseUrl + '/exportv2');
                    //Q.postToUrl(SubCategoryMasterService.baseUrl + '/exportv2');
                    Q.postToService({
                        service: CategoryWiseSalesService.baseUrl + '/ExcelExport',
                        request: {
                        },

                        target: '_blank'
                    });
                }
            });

            //buttons.push({
            //    title: 'In Detail',
            //    cssClass: 'send-button',
            //    //icon: 'fa-cloud-download',
            //    onClick: () => {

            //        var dialog = new Common.SalesSummaryReportDialog();
                     
            //        dialog.dialogOpen();
            //    }
            //});

            //buttons.push(Common.PdfExportHelper.createToolButton({
            //    grid: this,
            //    title: "Print",
            //    reportTitle: "Sales Items",
            //    onViewSubmit: () => this.onViewSubmit()
            //}));
            return buttons;
        }


    }
}